import { render, staticRenderFns } from "./DynamicSearch.vue?vue&type=template&id=56a50215"
import script from "./DynamicSearch.vue?vue&type=script&lang=js"
export * from "./DynamicSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports